exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".seminar-details[data-v-31a68ad2]{font-size:12px}[data-size*=md] .seminar-details[data-v-31a68ad2]{overflow:auto;height:100%;margin-right:10px;padding-right:10px;-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;font-size:13px}[data-v-31a68ad2] p{margin:0 0 .5em}.seminar-details__description[data-v-31a68ad2] img{max-width:100%;height:auto!important}.seminar-details__category[data-v-31a68ad2]{font-weight:600}.seminar-details__time span[data-v-31a68ad2]{border-bottom:1px dotted #2c3e50;cursor:help}.seminar-details__link a[data-v-31a68ad2]{color:#0083d0;text-decoration:underline}", ""]);

// exports
